module.exports = __webpack_public_path__ + "media/images/www/company/garbage-bin-throw-007fb720cd0632953549340531c347cb.svg";